<div class="setup-page" *ngIf="integration">
  <nav class="breadcrumb">
    <button type="button" class="link-btn" (click)="backToHub()">← Integrations</button>
  </nav>

  <header class="setup-header">
    <div class="icon" [style.background]="integration.accent">{{ integration.iconLabel }}</div>
    <div>
      <h1>{{ integration.name }}</h1>
      <p class="meta">{{ integration.vendor }} · {{ availabilityLabel(integration.availability) }}</p>
      <p class="desc">{{ integration.description }}</p>
    </div>
  </header>

  <div class="notice planned" *ngIf="isPlanned()">
    <strong>Coming soon</strong>
    — Full connector setup will appear here. Use the quick links below for today’s workflow, or see
    <code *ngIf="integration.docHint">{{ integration.docHint }}</code>
    in the repo for the integration roadmap.
  </div>

  <div class="notice beta" *ngIf="integration.availability === 'beta'">
    <strong>Beta</strong>
    — Core viewing and GIS tools are available now. Automated DXF → LRS import is planned next.
  </div>

  <section class="card" *ngIf="integration.setupSteps?.length">
    <h2>Setup guide</h2>
    <ol class="steps">
      <li *ngFor="let step of integration.setupSteps">
        <h3>{{ step.title }}</h3>
        <p>{{ step.body }}</p>
      </li>
    </ol>
  </section>

  <section class="card" *ngIf="integration.quickLinks?.length">
    <h2>Quick links</h2>
    <div class="link-grid">
      <button
        type="button"
        class="link-card"
        *ngFor="let link of integration.quickLinks"
        (click)="openLink(link.route)"
      >
        <span class="link-title">{{ link.label }}</span>
        <span class="link-desc" *ngIf="link.description">{{ link.description }}</span>
        <span class="link-arrow">Open →</span>
      </button>
    </div>
  </section>

  <section class="card features-card">
    <h2>Capabilities</h2>
    <ul>
      <li *ngFor="let f of integration.features">{{ f }}</li>
    </ul>
  </section>
</div>
